import pick from "lodash/fp/pick";

import { ticketPoolFormFields } from "./consts";

export const pickTicketPoolFormFields = pick(ticketPoolFormFields);
